import React from 'react';
import { observer } from 'mobx-react-lite';
import { BasePieChart } from './base/pie/base-pie-chart';
import { useRootStore } from '../../../providers/root-store-provider';
import { PieChartTypeEnum } from '../../../models/enums/pie-chart-type-enum';

type CountryChartType = {
    isFree?: boolean;
    isFullScreen?: boolean;
    includeMinorCategories?: boolean;
};

export const CountryChart: React.FC<CountryChartType> = observer(
    ({ isFree = false, isFullScreen, includeMinorCategories }: CountryChartType) => {
        const { portfolioStore, statisticStore } = useRootStore();
        const { countryRatio, countryRatioFullScreen } = statisticStore.ratiosStore;

        React.useEffect(() => {
            if (includeMinorCategories && !countryRatioFullScreen) {
                statisticStore.ratiosStore.fetchRatios(true);
            }
        }, [includeMinorCategories, countryRatioFullScreen, statisticStore.ratiosStore]);

        const chartData = includeMinorCategories ? countryRatioFullScreen : countryRatio;

        if (!chartData) {
            return null;
        }

        return (
            <BasePieChart
                currency={portfolioStore.selectedPortfolio.portfolioHistoryCurrencyCode}
                type={PieChartTypeEnum.Country}
                data={chartData.data}
                isFree={isFree}
                isFullScreen={isFullScreen}
            />
        );
    },
);
